import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'spw-card-subtags',
  styleUrl: 'spw-card-subtags.scss',
})
export class SpwCardSubtags {
  render() {
    return (
      <Host>
        <div class="spw-card-subtags">
          <slot></slot>
        </div>
      </Host>
    );
  }
}
